var Observable_1 = require('../../Observable');
var buffer_1 = require('../../operator/buffer');
Observable_1.Observable.prototype.buffer = buffer_1.buffer;
//# sourceMappingURL=buffer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/buffer.js
 ** module id = 324
 ** module chunks = 1
 **/